module.exports = __webpack_public_path__ + "static/electroavtosam-1a0ff81e9e1fdcd3bbdd9ddd79c5f2d4.webp";